import f from "copy-text-to-clipboard";
const T = async ({
  string: y,
  permittedCallback: o,
  deniedCallback: s
}) => navigator.permissions.query({ name: "clipboard-write" }).then((r) => {
  (r.state === "granted" || r.state === "prompt") && navigator.clipboard.writeText(y).then(() => {
    o == null || o();
  }).catch((p) => {
    console.error("COPY LINK ERROR:", p);
  }), r.state === "denied" && (document.queryCommandSupported("copy") ? (f(y), setTimeout(() => {
    o == null || o();
  })) : s == null || s());
}).catch(() => {
  s == null || s();
});
export {
  T as c
};
